<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.57324 4.42675L6.1768 7.82323C6.07917 7.92086 6.07917 8.07915 6.1768 8.17678L9.57324 11.5732C9.73074 11.7307 10 11.6192 10 11.3965V4.60353C10 4.3808 9.73073 4.26926 9.57324 4.42675Z"
    fill="currentColor"
  />
</svg>
